var React = require('react');

function RetweetAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M96 192H48c-21.36 0-32-25.9-17-41l80-80a24 24 0 0 1 34 0l80 80c15.11 15.1 4.35 41-17 41h-48v160h202.08a18.9 18.9 0 0 1 17.67 12.08 55.89 55.89 0 0 0 12.68 19.52c11.95 11.95 3.49 32.4-13.43 32.4H120a24 24 0 0 1-24-24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M609 361l-80 80a24 24 0 0 1-33.94 0l-80-80c-15.11-15.11-4.34-41 17-41h48V160H278a18.91 18.91 0 0 1-17.68-12.08 55.72 55.72 0 0 0-12.67-19.52c-12-12-3.49-32.4 13.42-32.4H520a24 24 0 0 1 24 24v200h48c21.39 0 32.06 25.9 17 41z","className":"fa-primary","key":2})]);
}

RetweetAlt.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = RetweetAlt;

RetweetAlt.default = RetweetAlt;
